import type { I18nLocale } from '#/i18n/types/I18nLocale';

import type { VolunteerDropdownData } from './types/VolunteerDropdownData';
import { volunteerDropdownDataEn } from './volunteerDropdownData.en';
import { volunteerDropdownDataEs } from './volunteerDropdownData.es';
import { volunteerDropdownDataPt } from './volunteerDropdownData.pt';

export const volunteerDropdownDataByLocale: Record<
  I18nLocale,
  VolunteerDropdownData
> = {
  en: volunteerDropdownDataEn,
  es: volunteerDropdownDataEs,
  pt: volunteerDropdownDataPt,
};
